































import { Vue, Component, Prop } from 'vue-property-decorator'
import { namespace } from 'vuex-class'

@Component({})
export default class OzSimpleModal extends Vue {
  @(namespace('browser').Getter) isPhone!: boolean
  @Prop({ default: 'large' }) size!: 'small' | 'large'
  showing = false

  get modalSizeClass(): string {
    switch (this.size) {
      case 'small':
        return 'md:w-135'
      case 'large':
        return 'md:w-180'
      default:
        return 'md:w-135'
    }
  }

  cancel(): void {
    this.$emit('cancel')
  }

  handlePageScroll(): void {
    // Disable / enable page scroll
    // Prevent page from scrolling when modal is open
    if (this.showing) {
      return document.querySelector('body')?.classList.add('overflow-hidden')
    }
    return document.querySelector('body')?.classList.remove('overflow-hidden')
  }

  mounted(): void {
    this.showing = true
    this.handlePageScroll()
  }

  beforeDestroy(): void {
    this.showing = false
    this.handlePageScroll()
  }
}
